import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { IconSizeEnum, PositionEnum, SdButtonComponent, SdTitleComponent } from '@seb/web-design-system/core';

@Component({
  selector: 'sd-card-user-info',
  templateUrl: './card-user-info.component.html',
  styleUrls: ['./card-user-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    SdTitleComponent,
    SdButtonComponent,
    TranslateModule
  ]
})
export class SdCardUserInfoComponent {
  positionEnum = PositionEnum;
  iconSize = IconSizeEnum;

  @Input()
  userInfo: any;

  @Input()
  titleLevel: number;

  @Output()
  showEditForm = new EventEmitter<boolean>();

  showEditInformationForm() {
    this.showEditForm.emit(true);
  }
}
